export const heading = 'Cover all your bases. ';
export const body =
  'We specialize across all areas of retirement — including income, healthcare, housing, and quality of life. This enables us to better manage a holistic plan to serve your unique needs.';
